export default __webpack_public_path__ + "static/media/bg-model-01.de65ec8c.glb";